export const DESCRIPTION_TEXTAREA_ROWS = 3;
